import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Routes } from 'Routes';
import { AuthSelectors } from '../redux';

export const AuthRoute: React.FC<RouteProps> = (props) => {
  const isAuthorized = useSelector(AuthSelectors.isAuthorized);

  if (!isAuthorized) {
    return <Route {...props} />;
  }

  return (
    <Route {...props} render={undefined} component={undefined}>
      <Redirect to={{ pathname: Routes.App }} />
    </Route>
  );
};
